export default {
    // eslint-disable-line
    init() {
      // JavaScript to be fired on the Serch page
      // Just hide search text if it empty
      const searchText = document.querySelector('.search-text');
      if (searchText.textContent.trim() === '') {
        searchText.style.display = 'none';
      } else {
        return;
      }
    },
  };
  


// WEBPACK FOOTER //
// ./scripts/routes/search.js